(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5306],{

/***/ 6660:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build-your-own",
      function () {
        return __webpack_require__(6295);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6886);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SILink = (param)=>{
    let { children , onClick =(e)=>{} , ...props } = param;
    const handleOnClick = (e)=>{
        // @ts-ignore
        onClick(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "".concat((_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), " ").concat(props.classes ? props.classes : ""),
        ...props,
        onClick: handleOnClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SILink);


/***/ }),

/***/ 6295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ build_your_own; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/styles/pages/build-your-own/index.module.scss
var index_module = __webpack_require__(5264);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/styles/components/build-your-own/find-favorite-product/index.module.scss
var find_favorite_product_index_module = __webpack_require__(7214);
var find_favorite_product_index_module_default = /*#__PURE__*/__webpack_require__.n(find_favorite_product_index_module);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/build-your-own/find-favorite-product/index.tsx





// @ts-ignore
const FindFavoriteProduct = (param)=>{
    let { pdfDetails  } = param;
    // these variables are used to animate the left and right image when this view are on screen.
    const ref = (0,react.useRef)(null);
    const isInView = (0,use_in_view/* useInView */.Y)(ref, {
        once: false
    });
    /**
     * in this section user can download the pdf file of the products.
     */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (find_favorite_product_index_module_default()).find_your_products,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "images ".concat(isInView ? "image_animation" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "desktop",
                        src: "/assets/images/decorations/build_your_own/build_your_own_page_left.webp",
                        alt: "download catalog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "desktop",
                        src: "/assets/images/decorations/build_your_own/build_your_own_page_right.webp",
                        alt: "download catalog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "ipad",
                        src: "/assets/images/decorations/build_your_own/build_your_own_ipad_left.webp",
                        alt: "download catalog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "ipad",
                        src: "/assets/images/decorations/build_your_own/build_your_own_ipad_right.webp",
                        alt: "download catalog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "mobile",
                        src: "/assets/images/decorations/build_your_own/build_your_own_mobile_left.webp",
                        alt: "download catalog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "mobile",
                        src: "/assets/images/decorations/build_your_own/build_your_own_mobile_right.webp",
                        alt: "download catalog"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "title_bold",
                        children: [
                            "find your favorite ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "products"
                        ]
                    }),
                    pdfDetails.Products_Catalog && pdfDetails.Products_Catalog.data && pdfDetails.Products_Catalog.data.attributes && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: pdfDetails.Products_Catalog.data.attributes.url,
                        className: "download_catalog",
                        target: "_blank",
                        download: "SIDR Products Catalog",
                        children: "download catalog"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/link/silink.tsx
var silink = __webpack_require__(5515);
;// CONCATENATED MODULE: ./src/pages/build-your-own.tsx





// @ts-ignore
function BuildYourOwn(param) {
    let { pdfDetails  } = param;
    /***
     * This page includes the header and footer components
     * The page contain list of data in that we have image, title, subtitle and description.
     */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (index_module_default()).banner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "img_left",
                        src: "/assets/images/banners/build_your_own/build_your_own_page_banner_left.webp",
                        alt: "leftbox"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "img_right",
                        src: "/assets/images/banners/build_your_own/build_your_own_page_banner_right.webp",
                        alt: "right box"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (index_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "title_text",
                                children: "craft your honey box"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "title_bold",
                                children: "super honey flavors"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "description",
                                children: [
                                    "The value of freedom to choose is understood when people make it with care. The honey box that you will create by carefully making these choices can offer you the opportunity to gift someone else, bring together the flavors you want to discover, or make them more economical.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Your purpose for creating these boxes is always special and exciting for us. With this motivation, we send you the product selections carefully made by you, by packaging them with the same care. Elevate your gifting experience with super honey flavors."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jar_boxes",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/images/gift_box/small_box/open_angle_gift_box_small.webp",
                                        alt: "small box"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner_box",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title_text",
                                                    children: "small box"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "description",
                                                    children: "7 types of honey of your choice"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(silink/* default */.Z, {
                                                    classes: "link",
                                                    href: "/build-your-own/small-box",
                                                    props: {
                                                        prefetch: false
                                                    },
                                                    children: "start to build"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/images/gift_box/large_box/open_angle_gift_box_large.webp",
                                        alt: "large box"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner_box",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title_text",
                                                    children: "large box"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "description",
                                                    children: "14 types of honey of your choice"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(silink/* default */.Z, {
                                                    classes: "link",
                                                    href: "/build-your-own/large-box",
                                                    props: {
                                                        prefetch: false
                                                    },
                                                    children: "start to build"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "bottom_rule"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFavoriteProduct, {
                        pdfDetails: pdfDetails
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var build_your_own = (BuildYourOwn);


/***/ }),

/***/ 7214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","find_your_products":"find-favorite-product_find_your_products__7ksry","about-image-in":"find-favorite-product_about-image-in__sbTbr","fade-in-honeycomb":"find-favorite-product_fade-in-honeycomb__CnHyt","dot-falling":"find-favorite-product_dot-falling__qLtXS","dot-falling-before":"find-favorite-product_dot-falling-before__89D8W","dot-falling-after":"find-favorite-product_dot-falling-after__1268f"};

/***/ }),

/***/ 6886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","link":"link_link__T8hPh","about-image-in":"link_about-image-in__JsJpN","fade-in-honeycomb":"link_fade-in-honeycomb__iJ7y6","dot-falling":"link_dot-falling__xjMoT","dot-falling-before":"link_dot-falling-before__Qz2nK","dot-falling-after":"link_dot-falling-after__fHF3N"};

/***/ }),

/***/ 5264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"build-your-own_banner__ZxCtj","container":"build-your-own_container__sfv7_","about-image-in":"build-your-own_about-image-in__gNPAR","fade-in-honeycomb":"build-your-own_fade-in-honeycomb__LWQsW","dot-falling":"build-your-own_dot-falling__OJUzm","dot-falling-before":"build-your-own_dot-falling-before__yMQXH","dot-falling-after":"build-your-own_dot-falling-after__tbA6z"};

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6660); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);